import { render, staticRenderFns } from "./OrderKidsDetailDialog.vue?vue&type=template&id=57133f23&scoped=true"
import script from "./OrderKidsDetailDialog.vue?vue&type=script&lang=js"
export * from "./OrderKidsDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderKidsDetailDialog.vue?vue&type=style&index=0&id=57133f23&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57133f23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57133f23')) {
      api.createRecord('57133f23', component.options)
    } else {
      api.reload('57133f23', component.options)
    }
    module.hot.accept("./OrderKidsDetailDialog.vue?vue&type=template&id=57133f23&scoped=true", function () {
      api.rerender('57133f23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/OderKids/OrderKidsDetailDialog.vue"
export default component.exports